import { Model } from "infrontjs";

export class Organisation extends Model
{
    static schema = {
        id: { type: 'string', default: null },
        name: { type: 'string', default: null },
        data: { type: 'object', default: null },
        settings: { type: 'object', default: null },
        premium: { type: 'object', default: null },
        createdAt: { type: 'datetime', default: null },
        updatedAt: { type: 'datetime', default: null }
    };
}
